var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function BureanInsurancesChanges() {
  this.init();
}

BureanInsurancesChanges.prototype = new Base();

BureanInsurancesChanges.prototype.init = function() {
  var $bureauInsurances = $('[data-bureau-insurances-changes]');
  if ($bureauInsurances.get(0) !== undefined) {
    ko.applyBindings(
      new model($bureauInsurances.data('bureau-insurances-changes')),
      $bureauInsurances.get(0)
    );
  }
};

module.exports = BureanInsurancesChanges;
